import { useState, useCallback } from 'react';
import axios from 'axios';
import debounce from 'lodash.debounce';
import { useSelector } from 'react-redux';

const useUserSearch = () => {
    const [loading, setLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [isSearchPerformed, setIsSearchPerformed] = useState(false);
    const token = useSelector(state => state.loginSlice.token);

    //TODO: Move to contestSlice
    const fetchData = async (search) => {
        if (!search.trim()) {
            setIsSearchPerformed(false);
            setSearchResults([]);
            return;
        }
        setLoading(true);
        setIsSearchPerformed(true);
        try {
            const response = await axios.get(`https://vmestemcpb.ru:8085/api/v1/user/search?q=${search}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setSearchResults(response.data);
        } catch (error) {
            console.error('Ошибка при получении данных пользователя', error);
        } finally {
            setLoading(false);
        }
    };

    const debouncedFetchData = useCallback(debounce(fetchData, 500), [token]);

    return {
        loading,
        searchResults,
        isSearchPerformed,
        debouncedFetchData
    };
};

export {useUserSearch};
